import { Controller } from '@hotwired/stimulus';
import logger from '../analytics/logger';

export default class extends Controller {
  static targets = ['successMessage', 'sendMessage'];

  static values = {
    id: String,
    email: String
  };

  sendMessage() {
    event.target.classList.add('u-visuallyHidden');
    this.successMessageTarget.classList.remove('u-visuallyHidden');
    this.successMessageTarget.innerHTML = `
      <h3 class="gzl-Heading u-typesetHeadingSmall u-spacingStack1">Starting a new message...</h3>`;

    setTimeout(() => {
      this.successMessageTarget.classList.add('u-visuallyHidden');
      this.sendMessageTarget.classList.remove('u-visuallyHidden');
    }, 15000);

    logger.trackElementClicked({
      label: 'Send question',
      elementId: 'Class finder details'
    });

    const mailtoLink = `mailto:${this.emailValue}?subject=FPU Class Question`;
    window.location.href = mailtoLink;
  }
}
